import ControlUnitCalls from '../../../model/controlUnit/Calls';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { nameReducer } from '../controlUnit.model';
import { ErrorRestST } from '../../../rest/rest.model';
import { MonitoringCalls } from '../../../model/monitoring/MonitoringCalls';

// ------------------------------------
// Thunks created with @reduxjs/toolkit
// ------------------------------------

export const fetchDeviceControlUnits = createAsyncThunk(
  `${nameReducer}/fetchDeviceControlUnits`,
  async (deviceId: string) => {
    const controlUnitCalls = new ControlUnitCalls();

    return await controlUnitCalls.getControlUnitsByDeviceId(deviceId);
  },
  // It is necessary because front need ErrorRestST['errorId']
  { serializeError: (e: unknown) => e as ErrorRestST }
);

export const fetchCurrentEventsControlUnits = createAsyncThunk(
  `${nameReducer}/fetchCurrentEventsControlUnits`,
  async (deviceId: string) => {
    const monitoringCalls = new MonitoringCalls();
    const response = await monitoringCalls.getCurrentEventsByID(deviceId);
    return response;
  },
  // It is necessary because front need ErrorRestST['errorId']
  { serializeError: (e: unknown) => e as ErrorRestST }
);

export const fetchCurrentSensorDataControlUnits = createAsyncThunk(
  `${nameReducer}/fetchCurrentSensorDataControlUnits`,
  async (deviceId: string) => {
    const monitoringCalls = new MonitoringCalls();
    const response = await monitoringCalls.getCurrentSensorDataByID(deviceId);
    return response;
  },
  // It is necessary because front need ErrorRestST['errorId']
  { serializeError: (e: unknown) => e as ErrorRestST }
);
